import React, { useRef, useState } from "react";
import { InfoIcon } from "../../../../svg/info-icon";
import ToolTipUsingPortal from "../../../toolTipUsingPortal/toolTipUsingPortal";
import { useTooltipData } from "./hooks/useTooltipData";

interface BadgeWithICellProps {
  value: {
    text: string;
    color?: string;
    bgColor?: string;
    displayText?: string;
    showInfoIcon?: boolean;
    fetchFn?: () => Promise<string>;
    maxWidth?: string;
  };
  [key: string]: any;
}

export const BadgeWithICell: React.FC<BadgeWithICellProps> = ({ value }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const parentRef = useRef<HTMLDivElement>(null);

  const { tooltipContent } = useTooltipData({
    showTooltip,
    fetchFn: value?.fetchFn,
    displayText: value?.displayText,
  });

  return (
    <>
      <div
        className="flex w-full flex-row items-center gap-2"
        onMouseEnter={() => setShowTooltip(value?.showInfoIcon ?? false)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <div
          className="table-cell-badge"
          style={{
            color: value.color || "#000000",
            backgroundColor: value.bgColor || "#F5F5F5",
          }}
        >
          {value.text}
        </div>
        <div ref={parentRef}>{value.showInfoIcon && <InfoIcon />}</div>
        {showTooltip && (
          <ToolTipUsingPortal
            placement="left"
            showTooltip={showTooltip}
            parentRef={parentRef}
            children={<div>{tooltipContent}</div>}
            wrapText
            maxWidth={value?.maxWidth ? value.maxWidth : ""}
          />
        )}
      </div>
    </>
  );
};

export default BadgeWithICell;
